import { SPACES } from 'common/constants/sizes';
import { GrayBackground } from 'components/base/layout-components';
import styled from 'styled-components';

export const StyledBackground = styled(GrayBackground)`
  padding: ${SPACES.small};
`;
